import React, { useState } from "react";
import {
  Dialog,
  AppBar,
  makeStyles,
  Toolbar,
  Typography,
} from "@material-ui/core";
import Crop from "../Crop/Crop";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#808080",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export default function DialogCrop(props) {
  const { imageDataUrl, isOpen, handleClose, load, typeload } = props;
  const classes = useStyles();
  const [title, setTitle] = useState("Ticket #");

  return (
    <Dialog fullScreen open={isOpen} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant='h4' className={classes.title}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Crop
        imageDataUrl={imageDataUrl}
        handleClose={handleClose}
        setTitle={setTitle}
        title={title}
        load={load}
        typeload={typeload}
      />
    </Dialog>
  );
}
